// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout_container__qAHwt","mainContent":"PageLayout_mainContent__1pZv-"};